// migrated 1:1 from @nexato/nx-core-module, #688
import { Activity } from "../../../entities/activity/activity";
import { ActivityComponent } from "./activityComponent";
import { Component, input, TemplateRef, viewChild } from '@angular/core';

@Component({
  selector: 'app-issue-status-changed',
  template: `
    <b>{{activity()?.actor?.displayName}}</b> hat den Status zu <b>{{activity()?.viewModel?.newStatus?.label}}</b> geändert <app-relative-time [timestamp]="activity()?.createdDateTime" />
    <ng-template #customIndicator>
      <app-issue-status-icon [issueStatus]="activity()?.viewModel?.newStatus"></app-issue-status-icon>
    </ng-template>
  `
})
export class IssueStatusChangedComponent implements ActivityComponent {

  readonly activity = input.required<Activity>();
  readonly ownerId = input<string>();

  private readonly indicatorTemplate = viewChild.required<TemplateRef<unknown>>('customIndicator');

  getIndicatorTemplate(): TemplateRef<unknown> | null {
    return this.indicatorTemplate();
  }
}
